import { Injectable } from '@angular/core';
import { EnvironmentService } from 'src/app/core/enviroment/environment.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

interface RouteGuardResponde {
  urls: string[];
}

@Injectable({
  providedIn: 'root'
})

export class RouteGuardService {
  private readonly uri = this.environmentService.getEnvVar('api_home');

  constructor(
    private environmentService: EnvironmentService,
    private http: HttpClient
  ) { }

  public getRouteGuard(): Observable<RouteGuardResponde>  {
    return this.http.get<any>(`${this.uri}/route-guard`);
  }
}
